export default __webpack_public_path__ + "static/media/euro-symbol.7d5add39.svg";